import React from 'react';
import emojis from 'theme/emoji';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import useStyle from './paymentMethodBlock.style';
import { classNames } from 'helpers/style/classNames';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';
import Payment from 'components/atoms/Images/Payment';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';

export type PaymentMethods =
  | 'cb'
  | 'cheque'
  | 'especes'
  | 'mandat_administratif'
  | 'virement';

export const PaymentMethodBlockView = ({
  selected,
  setSelected,
  isPublicShop
}: {
  selected: PaymentMethods | null;
  setSelected: (val: PaymentMethods) => void;
  isPublicShop?: boolean;
}) => {
  const classes = useStyle();
  return (
    <ContainerFullWidth>
      <HeaderText text="Mode de paiement" emoji={emojis['CreditCard']} />
      <FeatureContainer>
        <div className={classes.root}>
          <p>Méthode de paiement:</p>
          {!isPublicShop && (
            <>
              <div
                className={classNames([classes.line], {
                  condition: selected === 'cheque',
                  classe: classes.selectedLine
                })}
                onClick={() => setSelected('cheque')}
              >
                <div className={classes.textImageContainer}>
                  <p>Chèque</p>
                  <img
                    className={classes.image}
                    src={Payment['Cheque']}
                    alt="chèque"
                  />
                </div>
                {selected === 'cheque' && (
                  <FlatIcon icon={'Tick'} color="blue" />
                )}
              </div>
              {selected === 'cheque' && (
                <p className={classes.warningCheques}>
                  Pense à recopier le numéro de la commande au dos du chèque.
                </p>
              )}
              <div
                className={classNames([classes.line], {
                  condition: selected === 'especes',
                  classe: classes.selectedLine
                })}
                onClick={() => setSelected('especes')}
              >
                <div className={classes.textImageContainer}>
                  <p>Espèces</p>
                  <img
                    className={classes.image}
                    src={Payment['Euro1']}
                    alt="euro1"
                  />
                  <img
                    className={classes.image}
                    src={Payment['Euro2']}
                    alt="euro2"
                  />
                  <img
                    className={classes.image}
                    src={Payment['Billet10']}
                    alt="billet10"
                  />
                  <img
                    className={classes.image}
                    src={Payment['Billet20']}
                    alt="billet20"
                  />
                </div>
                {selected === 'especes' && (
                  <FlatIcon icon={'Tick'} color="blue" />
                )}
              </div>
              <div
                className={classNames([classes.line], {
                  condition: selected === 'cb',
                  classe: classes.selectedLine
                })}
                onClick={() => setSelected('cb')}
              >
                <div className={classes.textImageContainer}>
                  <p>Carte bancaire</p>
                  <img className={classes.image} src={Payment['CB']} alt="cb" />
                  <img
                    className={classes.image}
                    src={Payment['Mastercard']}
                    alt="cb mastercard"
                  />
                  <img
                    className={classes.image}
                    src={Payment['Visa']}
                    alt="cb visa"
                  />
                </div>
                {selected === 'cb' && <FlatIcon icon={'Tick'} color="blue" />}
              </div>
              <div
                className={classNames([classes.line], {
                  condition: selected === 'mandat_administratif',
                  classe: classes.selectedLine
                })}
                onClick={() => setSelected('mandat_administratif')}
              >
                <div className={classes.textImageContainer}>
                  <p>Mandat Administratif</p>
                  <img
                    className={classes.image}
                    src={Payment['Mandat']}
                    alt="Mandat"
                  />
                </div>
                {selected === 'mandat_administratif' && (
                  <FlatIcon icon={'Tick'} color="blue" />
                )}
              </div>
              <div
                className={classNames([classes.line], {
                  condition: selected === 'virement',
                  classe: classes.selectedLine
                })}
                onClick={() => setSelected('virement')}
              >
                <div className={classes.textImageContainer}>
                  <p>Virement</p>
                  <FlatIcon icon={'Bank'} />
                </div>
                {selected === 'virement' && (
                  <FlatIcon icon={'Tick'} color="blue" />
                )}
              </div>
            </>
          )}
          {isPublicShop && (
            <div
              className={classNames([classes.line], {
                condition: selected === 'cb',
                classe: classes.selectedLine
              })}
              onClick={() => setSelected('cb')}
            >
              <div className={classes.textImageContainer}>
                <p>Carte bancaire</p>
                <img className={classes.image} src={Payment['CB']} alt="cb" />
                <img
                  className={classes.image}
                  src={Payment['Mastercard']}
                  alt="cb mastercard"
                />
                <img
                  className={classes.image}
                  src={Payment['Visa']}
                  alt="cb visa"
                />
              </div>
              {selected === 'cb' && <FlatIcon icon={'Tick'} color="blue" />}
            </div>
          )}
        </div>
      </FeatureContainer>
    </ContainerFullWidth>
  );
};
